export default function TS_Decorators() {
  return (
    <div>
      <h1>TS Decorators</h1>
      <p>This is the TS Decorators page.</p>
    </div>
  );
}